import { ColumnDef } from "@tanstack/react-table";
import { TotalRow } from "../model";

export const totalColumns: ColumnDef<TotalRow>[] = [
  {
    header: "Total inflow GBP",
    accessorFn: (r) => r.totalInflowGBP,
  },
  {
    header: "Total outflow GBP",
    accessorFn: (r) => r.totalOutflowGBP,
  },
];
